module.exports = new __parcel__URL__("projects.9c799fec.jpeg").toString();